module.exports = __webpack_public_path__ + "assets/recordings.f96bf638.svg";